 
                        <nb-card  *ngIf="stream"  [nbSpinner]="loading" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">Приймати донати?</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				   <nb-toggle
					  [disabled]="!authService.currentTariff?.donateAvailable"
				     labelPosition="left"
				      [(checked)]="donateOn" 
				      (checkedChange)="toggleDonateOn()" 
				      status="primary">
				      <span *ngIf="donateOn">Так</span>
				      <span *ngIf="!donateOn">Ні</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>
                           
                            
                            </nb-card>
 
  


 
